import React from 'react';

import RemoteErrorsInterceptor, { withErrors } from 'ra-remote-validator';
import {
  ReferenceInput,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
} from 'react-admin';
import { compose } from 'recompose';

import Edit from '../components/form/Edit';
import ColorInput from '../components/inputs/ColorInput';

const FolderEdit = ({ dispatch, validate, errors, ...props }) => {
	return (
		<Edit title="name" {...props}>
			<SimpleForm variant="outlined" redirect="list" validate={validate}>
				<RemoteErrorsInterceptor errors={errors} dispatch={dispatch} />
				<ReferenceInput
					source="bot_id"
					reference="bots"
					fullWidth
					allowEmpty={true}
					emptyText="ra.boolean.all"
					disabled={true}
				>
					<SelectInput optionText="name" />
				</ReferenceInput>
				<TextInput validate={required()} source="name" fullWidth />
				<ColorInput source="color" />
			</SimpleForm>
		</Edit>
	);
};
export default compose(withErrors)(FolderEdit);
